import React from 'react';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import BlockImageCollage from '../BlockImageCollage/BlockImageCollage';

interface ImageSerializerProps {
  value: { images: CloudinaryImageType[] };
}

export const ImagesBlock = ({ value: { images } }: ImageSerializerProps) => <BlockImageCollage images={images} />;
